import type { RootState } from '@/store';

export const mapInfoSelector = (state: RootState) => state.map.mapInfo;
